import React, { Component } from "react";
import Actions from "./common/Actions";

import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";

import Colour from "./adjust/hsl/Colour";

import IconBrightness from "../icons/toolbar/menu/adjust/Brightness";
import IconContrast from "../icons/toolbar/menu/adjust/Contrast";
import IconSaturation from "../icons/toolbar/menu/adjust/Saturation";
import IconHighlights from "../icons/toolbar/menu/adjust/Highlights";
import IconHSL from "../icons/toolbar/menu/adjust/HSL";
import IconExposure from "../icons/toolbar/menu/adjust/Exposure";
import IconSettings from "../icons/toolbar/menu/adjust/Settings";

import Color from "../../../utils/Color";

import HSLModal from "../modal/HSLModal";

const INPUTS = [
  {
    id: 0,
    icon: <IconBrightness />,
    title: "Brightness",
    style: "brightness",
    key: "brightness",
    min: -1,
    max: 1,
    step: 0.025,
    showInputRange: true,
  },
  {
    id: 1,
    icon: <IconContrast />,
    title: "Contrast",
    style: "contrast",
    key: "contrast",
    min: -1,
    max: 1,
    step: 0.025,
    showInputRange: true,
  },
  {
    id: 2,
    icon: <IconSaturation />,
    title: "Saturation",
    style: "saturation",
    key: "saturation",
    min: -1,
    max: 1,
    step: 0.025,
    showInputRange: true,
  },
  {
    id: 3,
    icon: <IconHighlights />,
    title: "Highlights",
    style: "highlights",
    key: "highlights",
    min: 0,
    max: 2,
    step: 0.025,
    showInputRange: true,
  },
  {
    id: 4,
    icon: <IconHSL />,
    title: "HSL",
    key: "hsl",
    style: "hsl",
    showInputRange: false,
  },
  {
    id: 5,
    icon: <IconExposure />,
    title: "Exposure",
    style: "exposure",
    key: "exposure",
    min: -1,
    max: 1,
    step: 0.025,
    showInputRange: true,
  },
  // {
  //   id: 6,
  //   icon: <IconSettings />,
  //   title: "Settings",
  //   style: "settings",
  //   key: "settings",
  // },
];
export default class Adjust extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeAdjustment: "brightness",
      activeIndex: 0,
      inputs: INPUTS,
      adjustments: { ...props.adjustments },
    };
    this.hslPicker = React.createRef();
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps;
  }

  render() {
    let { activeAdjustment, adjustments, activeIndex, inputs } = this.state;
    return (
      <div className="adjust">
        <Actions
          showInputRange={activeAdjustment !== "hsl" ? true : false}
          adjustment={activeAdjustment}
          value={adjustments[activeAdjustment]}
          min={inputs[activeIndex].min}
          max={inputs[activeIndex].max}
          step={inputs[activeIndex].step}
          undoDisabled={this.props.undoDisabled}
          redoDisabled={this.props.redoDisabled}
          onUndoClicked={this.props.onUndoClicked}
          onRedoClicked={this.props.onRedoClicked}
          onValueChange={(value) => {
            adjustments[activeAdjustment] = parseFloat(value);
            this.props.onUpdated(adjustments);
          }}
        />
        <Tab.Container defaultActiveKey="brightness">
          <Tab.Content className="adjust-contents">
            {this._renderMenuContents()}
          </Tab.Content>
          <div className="menu">{this._renderMenu()}</div>
        </Tab.Container>
      </div>
    );
  }

  _renderNavItems() {
    let { inputs } = this.state;
    return inputs.map((input, index) => {
      return (
        <Nav.Item
          key={input.key}
          onClick={() => {
            if (input.key == "settings") {
              this.props.onSettingsClicked();
              return;
            }

            if (input.key == "hsl") {
              this.props.onHSLClicked();
              return;
            }

            this.setState({
              activeAdjustment: input.key,
              activeIndex: index,
            });
          }}
        >
          <Nav.Link key={input.key} eventKey={input.key}>
            {input.icon}
          </Nav.Link>
        </Nav.Item>
      );
    });
  }

  _renderMenu() {
    return (
      <Nav variant="" className="flex-nowrap" justify>
        {this._renderNavItems()}
      </Nav>
    );
  }

  _renderMenuContents() {
    let { inputs, adjustments, filter } = this.state;
    return inputs.map((input) => {
      return (
        <Tab.Pane key={input.key} eventKey={input.key}>
          {input.key === "hsl" && (
            <div className="hsl-widgets">
              <Colour
                onColorSelected={(color) => {
                  let hslaValues = Color.rgbaToHsla(color.value);
                  // TODO: what does this do??
                  this.hslPicker.handleHueChange(hslaValues.h);
                }}
              />

              <HSLModal
                show={this.props.showHSL}
                hsl={adjustments.hsl}
                filter={filter}
                onFilterUpdated={this.props.onFilterUpdated}
                onUpdated={(hsl) => {
                  adjustments.hsl = hsl;

                  this.props.onUpdated(adjustments);
                }}
                onHide={() => this.props.setShowHSL(false)}
              />
            </div>
          )}
          {input.title}
        </Tab.Pane>
      );
    });
  }
}
